import {
  defaultCellRenderer,
  getAging,
  defaultGroupRenderer as groupRenderer,
  generateMultiFilterConfigFromModel, columnAvatarRenderer
} from "../utils/utils.jsx";
import {WIDGET_KEYS} from "./WidgetKeys.jsx";
import {DateHelper} from "@bryntum/schedulerpro";
import {
  cellMenuItemCollapseAllRows,
  cellMenuItemCollapseRow, cellMenuItemRemoveRow,
  entitySendBoardAlert
} from "../utils/gridCellMenuUtils.jsx";
import {SWIVU_GROUP_CONTEXT_MENU_SELECTOR} from "./OtherKeys.jsx";
import { User } from "../../bryntum-lib/models/User.jsx";

const USER_VIEW_FILTER_FIELD_CONFIG = {
  ...generateMultiFilterConfigFromModel(User),
  roleName: { type: "_swivu_settings" }
};

const userGridRowExpander = {
  column: {
    hidden: true,
  },
  // refreshOnRecordChange: true, // Todo: fix changing role duplicate grids in rowExpander instead of removing old grid
  dataField: "grantsTextOnly",
  widget: {
    loadRecord(parentRecord) {
      if (parentRecord.roles) {
        this.columns.getById("grant").text = `${parentRecord.roleName} Permissions`;
      }
    },
    ref: "grantsGrid",
    type: WIDGET_KEYS.swivuPreferenceStyleGrid,
    autoHeight: true,
    style: "margin: auto;",
    columns: [{
      id: "grant",
      text: "Permissions",
      field: "description",
      htmlEncode: false,
      renderer(e) {
        return `<div style="text-wrap: wrap;">${e.value}</div>`
      }
    }],
    maxWidth: "55em",
    features: {
      cellMenu: false,
      headerMenu: false,
      cellEdit: false,
      sort: false,
      filter: false,
    },
  }
}

export const ScheduleUserConfig = {
  minHeight: "30em",
  height: "100%",
  flex: 1,
  filterFeature: {
    pickerConfig: {
      fields: USER_VIEW_FILTER_FIELD_CONFIG
    },
    closeEmptyPopup: true
  },
  cellMenuFeature: {
    clickTriggerSelector: SWIVU_GROUP_CONTEXT_MENU_SELECTOR,
    items: {
      cut: false,
      copy: false,
      paste: false,
      filterStringEquals: false,
      filterDisable: false,
      removeRow: cellMenuItemRemoveRow(),
      collapseRow: cellMenuItemCollapseRow(),
      collapseAllRows: cellMenuItemCollapseAllRows(),
      entitySendBoardAlert: entitySendBoardAlert()
    }
  },
  rowExpanderFeature: userGridRowExpander,
  selectionModeFeature: {
    multiSelect: false,
  },
  groupFeature: "roleName",
  listeners: {
    // These listeners are being triggered from row expander
    rowExpand(e) {
      e.record.isGridRowExpanded = true;
      e.widget.loadRecord(e.record);
    },
    rowCollapse(e) {
      e.record.isGridRowExpanded = false;
    }
  },
  columns: [
    {
      id: "id",
      field: "id",
      text: "User Id",
      editor: false,
      maxWidth: "8em",
      renderer: defaultCellRenderer,
      groupRenderer,
      flex: 1,
      filterable: false,
      afterRenderCell({ cellElement, record }) {
        if (record.isPhantom) {
          cellElement.innerText = defaultCellRenderer({ value: null});
        }
      }
    },
    {
      id: "contactButton",
      type: WIDGET_KEYS.contactColumn
    },
    {
      id: "name",
      field: "name",
      text: "Name",
      // Todo: Use EntityMainNameColumn
      type: WIDGET_KEYS.swivuSortColumn,
      cellCls: 'flex gap-[0.5em]',
      renderer: ({record, size}) => (columnAvatarRenderer({
        image: record.profileImageURL,
        name: record.name,
        archived: record.archived,
        size: size.configuredHeight
      })),
      groupRenderer,
      flex: 1,
      editor: false,
    },
    {
      id: "email",
      field: "email",
      text: "Email",
      type: WIDGET_KEYS.swivuSortColumn,
      editor: WIDGET_KEYS.fieldEmail,
      cellCls: "swivu-copy-icon-cell",
      renderer: ({ value }) => {
        const dataset = (v) => ({
          id: v.id,
          type: v.type,
        });

        const icon = value ? {
          tag: "i",
          class: "fa-thin fa-copy cursor-pointer dark:text-[#ffffff] text-[#000000] transition-colors duration-300 ease-in-out hover:opacity-70",
          dataset: dataset({ id: "email", type: "iconType" }),
        } : "";

        return [
          {
            tag: "span",
            text: defaultCellRenderer({ value }),
            class: "mr-[0.5em]",
          },
          icon
        ]
      },
      groupRenderer,
      flex: 1,
    },
    {
      id: "role",
      type: WIDGET_KEYS.userRoleColumn,
      field: "roleName",
    },
    { type: WIDGET_KEYS.swivuUserGrantViewButtonColumn },
    {
      id: "user-aging",
      text: "Age",
      field: "aging",
      flex: 1,
      editor: false,
      filterable: false,
      type: "agingColumn",
      groupRenderer({ groupRowFor, count }) {
        return groupRowFor ? groupRenderer({ groupRowFor: DateHelper.formatCount(getAging(groupRowFor), 'day'), count }): defaultCellRenderer({ value: null });
      }
    },
    {
      id: "user-last-interaction-hq",
      text: "Last Interaction HQ",
      field: "lastInteractionHQ",
      flex: 1,
      filterable: false,
      editor: false,
      renderer(e) {
        return e.value ? DateHelper.format(new Date(e.value), 'MM/DD/YYYY hh:mm A'): defaultCellRenderer({ value: null });
      },
      groupRenderer({ groupRowFor, count }) {
        return groupRowFor ? groupRenderer({ groupRowFor: DateHelper.format(new Date(groupRowFor), 'MM/DD/YYYY hh:mm A'), count }): defaultCellRenderer({ value: null });
      }
    },
    {
      id: "user-last-interaction-workforce",
      text: "Last Interaction Workforce",
      field: "lastInteractionWorkforce",
      flex: 1,
      filterable: false,
      editor: false,
      renderer(e) {
        return e.value ? DateHelper.format(new Date(e.value), 'MM/DD/YYYY hh:mm A'): defaultCellRenderer({ value: null });
      },
      groupRenderer({ groupRowFor, count }) {
        return groupRowFor ? groupRenderer({ groupRowFor: DateHelper.format(new Date(groupRowFor), 'MM/DD/YYYY hh:mm A'), count }): defaultCellRenderer({ value: null });
      }
    },
  ],
}
